import { Launch as LaunchIcon } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  LinearProgress,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import uniq from "lodash/uniq";
import type { FC } from "react";
import { useCustomerWithId } from "../../customers/useCustomerWithId";
import { useProducts } from "../../admin/products/useProducts";
import OrderStatusView from "../../orders/orderStatus/OrderStatusView";
import type { CostOrderResponse } from "../costApi";
import { formatDate } from "../../data/dataUtils";

const OrderProducts: FC<{ ids: string[] }> = ({ ids }) => {
  const { products, isLoading } = useProducts();
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <List>
      {uniq(ids).map((id) => (
        <ListItem key={id}>{products.find((p) => p.id === id)?.name ?? `n.d. (${id})`}</ListItem>
      ))}
    </List>
  );
};

interface Props {
  readonly date: string;
  readonly order: CostOrderResponse;
}

const OrderCard: FC<Props> = ({ date, order }) => {
  const { customer } = useCustomerWithId(order.customerId);
  return (
    <Card>
      <CardHeader title={`Zamówienie ${order.id.userFriendlyId}`} />
      <CardContent>
        <Typography>{formatDate(date)}</Typography>
        <OrderStatusView value={order.status} gutterBottom={order.price === null} />
        {order.price !== null && <Typography gutterBottom>{`Cena: ${order.price} ${order.currency}`}</Typography>}
        <Typography variant="subtitle2" gutterBottom>
          Klient
        </Typography>
        <Typography variant="h6" gutterBottom>
          {customer?.name}
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Produkty
        </Typography>
        <OrderProducts ids={order.productIds} />
      </CardContent>
      <CardActions>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button variant="outlined" startIcon={<LaunchIcon />} href={`/orders/${order.id.id}`} target="_blank">
            Zobacz zamówienie
          </Button>
        </Stack>
      </CardActions>
    </Card>
  );
};

export default OrderCard;
